import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Diagnostics() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/diagnostics").then((r) => setRows(r.data)); }, []);

  return (
    <div className="p-8 space-y-6" data-testid="diagnostics-page">
      <header>
        <div className="overline">// diagnostics · log</div>
        <h1 className="font-display font-black text-3xl mt-1">Diagnostic Queries</h1>
        <p className="text-zinc-500 text-sm mt-1">{rows.length} AI diagnostics across all mechanics.</p>
      </header>

      <div className="gs-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="border-b border-zinc-900 overline">
            <tr className="text-left">
              <th className="px-4 py-2.5">Mechanic</th>
              <th className="px-4 py-2.5">Query</th>
              <th className="px-4 py-2.5">Car #</th>
              <th className="px-4 py-2.5">Vehicle</th>
              <th className="px-4 py-2.5">DTC</th>
              <th className="px-4 py-2.5 text-right">Conf</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((d) => (
              <tr key={d.id} className="border-b border-zinc-900 hover:bg-zinc-900/40 align-top" data-testid={`diag-row-${d.id}`}>
                <td className="px-4 py-3">
                  <Link to={`/mechanics/${d.mechanic_id}`} className="text-zinc-200 hover:text-amber-500 text-sm">{d.mechanic_name}</Link>
                </td>
                <td className="px-4 py-3">
                  <div className="text-zinc-200 text-sm whitespace-pre-line">{d.query_text}</div>
                  <div className="text-xs text-zinc-500 mt-1 whitespace-pre-line">{d.ai_response}</div>
                </td>
                <td className="px-4 py-3">
                  {d.car_number ? <span className="font-mono-data text-xs text-amber-300 border border-amber-500/40 px-1.5 py-0.5 bg-amber-500/10">{d.car_number}</span> : <span className="text-zinc-700">—</span>}
                </td>
                <td className="px-4 py-3 text-zinc-400 text-sm">{d.vehicle || <span className="text-zinc-700">—</span>}</td>
                <td className="px-4 py-3">{d.dtc_code ? <span className="dtc-badge">{d.dtc_code}</span> : <span className="text-zinc-700">—</span>}</td>
                <td className="px-4 py-3 text-right"><span className="confidence-badge">{d.confidence}%</span></td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={6} className="px-4 py-6 text-center text-zinc-600 text-sm">No diagnostics yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
